import { Fragment, Component } from 'react';
import { get } from 'lodash/fp';
import elementType from 'prop-types-extra/lib/elementType';
import Col from 'react-bootstrap/lib/Col';
import Row from 'react-bootstrap/lib/Row';
import Observer from 'react-intersection-observer';
import PropTypes from 'prop-types';
import Sticky from 'react-stickynode';
import MediaQuery from 'react-responsive';
import { animateScroll } from 'react-scroll';
import cns from 'classnames';

import Section from 'components/Section';
import Modal from 'components/Modal';
import Breadcrumbs from 'components/Breadcrumbs';
import CmsBlock from 'components/CmsBlock';
import SellWidget from 'components/SellWidget';
import BrandButton from 'components/BrandButton';
import ClientRender from 'components/ClientRender';
import WelcomeBanner from 'components/WelcomeBanner';
import { SCREEN_SM_MAX } from 'constants/breakpointSizes';

import LinkBoxes from './LinkBoxes';
import FilterBlocks from '../../FilterBlocks';
import ActiveFiltersList from '../../ActiveFiltersList';
import CollapseFilters from './CollapseFilters';
import TopOptions from './TopOptions';
import AdList from './AdList';
import FavoritesCounter from './FavoritesCounter';

import cn from './styles.local.less';
import NoResultsBlock from './NoResultsBlock';

const MODAL_ID = 'sideBarModal';

const renderNothing = () => null;

export default class SearchContent extends Component {
  static propTypes = {
    activeFiltersListProps: PropTypes.object.isRequired,
    adListProps: PropTypes.object.isRequired,
    breadcrumbs: PropTypes.array.isRequired,
    breadcrumbsHtml: PropTypes.string,
    cmsContent: PropTypes.object.isRequired,
    enableStickyTopBar: PropTypes.bool.isRequired,
    favoritesCounterProps: PropTypes.object.isRequired,
    formName: PropTypes.string.isRequired,
    hasActiveFilters: PropTypes.bool.isRequired,
    initialForm: PropTypes.object.isRequired,
    isModalActive: PropTypes.bool.isRequired,
    isUnpublishedAdSearch: PropTypes.bool,
    LeftSide: elementType,
    linkBoxProps: PropTypes.object.isRequired,
    onExtraFiltersOpen: PropTypes.func,
    onFilterRemove: PropTypes.func,
    onFiltersChanged: PropTypes.func,
    onFiltersModalClose: PropTypes.func.isRequired,
    onFiltersModalShow: PropTypes.func.isRequired,
    onFiltersModalSubmit: PropTypes.func,
    onLoadPageClick: PropTypes.func,
    onRemoveAllFiltersClick: PropTypes.func,
    onSortChanged: PropTypes.func,
    onToggleAdDislikeClick: PropTypes.func.isRequired,
    onToggleAdFavoriteClick: PropTypes.func.isRequired,
    sellWidgetHtml: PropTypes.object,
    topOptionsProps: PropTypes.object,
    welcomeBannerProps: PropTypes.object,
    withExtraFilters: PropTypes.bool,
    withWelcomeBanner: PropTypes.bool,
    exactAdsCount: PropTypes.number,
  };

  static defaultProps = {
    LeftSide: get(['children']),
    withWelcomeBanner: true,
  };

  state = {
    isExtraFiltersOpen: false,
    isTopBarSticky: false,
  };

  mayBeScrollToTop = () => {
    const { isTopBarSticky } = this.state;

    if (isTopBarSticky) {
      window.scrollTo(0, 0);
    }
  };

  handleFiltersModalShow = () => {
    const { onFiltersModalShow } = this.props;

    this.setState({ isExtraFiltersOpen: false }, () => {
      onFiltersModalShow();
    });
  };

  handleExtraFiltersShow = () => {
    this.setState({ isExtraFiltersOpen: true }, () => {
      animateScroll.scrollToTop({
        containerId: MODAL_ID,
        duration: 0,
      });
    });
  };

  handleSubmitButtonClick = () => {
    const { onFiltersModalSubmit } = this.props;

    window.scrollTo(0, 0);

    onFiltersModalSubmit();
  };

  handleClearAllFiltersInModal = () => {
    const { onFiltersModalClose, onRemoveAllFiltersClick } = this.props;

    onRemoveAllFiltersClick();
    onFiltersModalClose();

    this.mayBeScrollToTop();
  };

  handleRemoveAllFiltersClick = () => {
    const { onRemoveAllFiltersClick } = this.props;

    onRemoveAllFiltersClick();
    this.mayBeScrollToTop();
  };

  handleFilterItemRemoveClick = (...args) => {
    const { onFilterRemove } = this.props;

    onFilterRemove(...args);
    this.mayBeScrollToTop();
  };

  handleTopBarIntersection = (isTopBarVisible) => {
    const isSticky = !isTopBarVisible;

    this.setState(({ isTopBarSticky }) =>
      isTopBarSticky === isSticky ? null : { isTopBarSticky: isSticky },
    );
  };

  handleSortChanged = () => {
    const { onSortChanged } = this.props;

    onSortChanged().then(this.mayBeScrollToTop);
  };

  renderAds() {
    const {
      adListProps,
      onLoadPageClick,
      onToggleAdDislikeClick,
      onToggleAdFavoriteClick,
    } = this.props;

    return (
      <AdList
        {...adListProps}
        loadPage={onLoadPageClick}
        onToggleAdFavoriteClick={onToggleAdFavoriteClick}
        onToggleAdDislikeClick={onToggleAdDislikeClick}
      />
    );
  }

  renderCollapseFilters({
    onExtraFiltersOpen,
    withEquipments,
    initialOpenedMakes,
  }) {
    const { formName, initialForm, onFiltersChanged, withExtraFilters } =
      this.props;

    return (
      <CollapseFilters
        formName={formName}
        initialForm={initialForm}
        onExtraFiltersOpen={onExtraFiltersOpen}
        onFiltersChanged={onFiltersChanged}
        withExtraFilters={withExtraFilters}
        withEquipments={withEquipments}
        initialOpened={{ makes: initialOpenedMakes }}
      />
    );
  }

  renderFiltersModal() {
    const { isExtraFiltersOpen } = this.state;
    const { onFiltersModalClose, formName, hasActiveFilters, isModalActive } =
      this.props;

    return (
      <Modal
        id={MODAL_ID}
        animation={false}
        onHide={onFiltersModalClose}
        show={isModalActive}
      >
        <Modal.Header closeButton className={cn.filterModalHeader}>
          <Modal.Title className={cn.filterModalTitle}>
            {hasActiveFilters ? (
              <span onClick={this.handleClearAllFiltersInModal}>
                {__('search.clearAll')}
              </span>
            ) : null}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className={cn.filterModalBody}>
          {isExtraFiltersOpen ? (
            <FilterBlocks formName={formName} />
          ) : (
            <Fragment>
              {this.renderCollapseFilters({
                onExtraFiltersOpen: this.handleExtraFiltersShow,
              })}
            </Fragment>
          )}
        </Modal.Body>
        <Modal.Footer>
          <BrandButton
            block
            bsSize="large"
            data-qa-selector="submit-search"
            onClick={this.handleSubmitButtonClick}
          >
            {__('search.modal.filters.submitBtnText')}
          </BrandButton>
        </Modal.Footer>
      </Modal>
    );
  }

  render() {
    const {
      LeftSide,
      activeFiltersListProps,
      breadcrumbs,
      breadcrumbsHtml,
      cmsContent,
      favoritesCounterProps,
      onExtraFiltersOpen,
      sellWidgetHtml,
      welcomeBannerProps,
      topOptionsProps,
      withWelcomeBanner,
      isUnpublishedAdSearch,
      linkBoxProps,
      exactAdsCount,
    } = this.props;
    const { isTopBarSticky } = this.state;

    const { title, sidebar, content } = cmsContent;
    const { imageUrl } = welcomeBannerProps;

    return (
      <Fragment>
        {withWelcomeBanner && imageUrl && (
          <WelcomeBanner {...welcomeBannerProps} />
        )}

        <Row className={cn.content}>
          <Col mdPush={3} md={9}>
            <div className="visible-xs visible-sm">
              <LeftSide children={null} />
            </div>

            {!imageUrl && <h1 className={cn.title}>{title}</h1>}

            <Observer onChange={this.handleTopBarIntersection}>
              <div className={cn.filtersContainer}>
                {isUnpublishedAdSearch || exactAdsCount === 0 ? (
                  <NoResultsBlock
                    isUnpublished={isUnpublishedAdSearch}
                    {...topOptionsProps}
                    {...activeFiltersListProps}
                  />
                ) : null}

                <div>
                  <TopOptions
                    {...topOptionsProps}
                    {...activeFiltersListProps}
                    onSortChanged={this.handleSortChanged}
                    onShowModalClick={this.handleFiltersModalShow}
                  />
                  <ActiveFiltersList
                    {...activeFiltersListProps}
                    onRemoveAllClick={this.handleRemoveAllFiltersClick}
                    onItemRemove={this.handleFilterItemRemoveClick}
                  />
                </div>
              </div>
            </Observer>

            {/* react-responsive can't match media on the server, so this only
                renders after hydration to keep server and client markup equal */}
            <ClientRender renderLoader={renderNothing}>
              {({ isMounted }) =>
                isMounted && (
                  <MediaQuery query={SCREEN_SM_MAX}>
                    <Sticky activeClass={cn.topOptionsSticky} innerZ={4}>
                      <div
                        className={cns(cn.topOptionsStickyContent, {
                          hidden: !isTopBarSticky,
                        })}
                      >
                        <TopOptions
                          {...topOptionsProps}
                          {...activeFiltersListProps}
                          onSortChanged={this.handleSortChanged}
                          onShowModalClick={this.handleFiltersModalShow}
                        />
                        <ActiveFiltersList
                          {...activeFiltersListProps}
                          onRemoveAllClick={this.handleRemoveAllFiltersClick}
                          onItemRemove={this.handleFilterItemRemoveClick}
                          maxFiltersToShow={3}
                          isCollapsible={false}
                        />
                      </div>
                    </Sticky>
                  </MediaQuery>
                )
              }
            </ClientRender>

            {this.renderAds()}

            <SellWidget {...sellWidgetHtml} />

            <CmsBlock
              className={cn.subContent}
              content={content}
              isDefaultStyles
            />
          </Col>
          <Col md={3} mdPull={9}>
            <div className="hidden-xs hidden-sm">
              <LeftSide children={null} />
            </div>

            <div
              className={cns(
                'hidden-xs hidden-sm',
                cn.root,
                cn.favoritesCountContainer,
              )}
            >
              <FavoritesCounter {...favoritesCounterProps} />
            </div>

            <div className={cns('hidden-xs hidden-sm', cn.root)}>
              {this.renderCollapseFilters({
                initialOpenedMakes: true,
                onExtraFiltersOpen,
                withEquipments: false,
              })}
            </div>

            <LinkBoxes {...linkBoxProps} />

            <div className={cn.sidebarCmsBlock}>
              <CmsBlock content={sidebar} />
            </div>
          </Col>
        </Row>

        {this.renderFiltersModal()}

        <Section>
          <Breadcrumbs items={breadcrumbs} cmsHtml={breadcrumbsHtml} />
        </Section>
      </Fragment>
    );
  }
}
